import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="weather"
export default class extends Controller {
    static targets = ["weatherContainer"]

    change(event) {
        fetch(event.currentTarget.dataset.weatherUrl)
        .then(response => response.text())
        .then(html => {
            this.weatherContainerTarget.innerHTML = html
        })
    }
}
